export const enum RequestedDataEntityLevel {
  ClaimSet = 1,
  ClaimEntity = 2,
  Claimant = 3,
}
